/**
 * 曜日 ValueObject
 */
export type DayOfWeek =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

/**
 * 曜日表示ラベル
 */
export const DAY_OF_WEEK_LABELS: Record<DayOfWeek, string> = {
  monday: '月曜日',
  tuesday: '火曜日',
  wednesday: '水曜日',
  thursday: '木曜日',
  friday: '金曜日',
  saturday: '土曜日',
  sunday: '日曜日'
};

/**
 * 曜日短縮ラベル
 */
export const DAY_OF_WEEK_SHORT_LABELS: Record<DayOfWeek, string> = {
  monday: '月',
  tuesday: '火',
  wednesday: '水',
  thursday: '木',
  friday: '金',
  saturday: '土',
  sunday: '日'
};

/**
 * 週番号 ValueObject
 * - 1-5: 第1週〜第5週
 * - 'all': 毎週
 */
export type WeekNumber = 1 | 2 | 3 | 4 | 5 | 'all';

/**
 * 週番号表示ラベル
 */
export const WEEK_NUMBER_LABELS: Record<WeekNumber, string> = {
  1: '第1週',
  2: '第2週',
  3: '第3週',
  4: '第4週',
  5: '第5週',
  all: '毎週'
};

/**
 * 時間条件 ValueObject
 * 注意: camelCaseを使用（バックエンドAPIと統一）
 */
export interface TimeCondition {
  weekNumber: WeekNumber;   // 週番号
  dayOfWeek: DayOfWeek;     // 曜日
  startTime: string;        // 開始時間 (HH:mm形式)
  endTime: string;          // 終了時間 (HH:mm形式)
}

/**
 * 時間条件を日本語で表示する
 * @param condition TimeCondition 時間条件オブジェクト
 * @returns string フォーマット済み文字列（例: "毎週月曜日 10:00-16:00"）
 */
export function formatTimeCondition(condition: TimeCondition): string {
  const weekLabel = WEEK_NUMBER_LABELS[condition.weekNumber];
  const dayLabel = DAY_OF_WEEK_LABELS[condition.dayOfWeek];
  return `${weekLabel}${dayLabel} ${condition.startTime}-${condition.endTime}`;
}
